import logoSrc from '../assets/logo-neuroforge-full-brain.png'

interface LogoProps {
  size?: number
  className?: string
}

export function Logo({ size = 32, className }: LogoProps) {
  return (
    <img
      src={logoSrc}
      alt="NeuroForge"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  )
}

export { logoSrc }
